export const FILTROS_VAZIOS = {
  busca: "",
  nome: "",
  cpf: "",
  perfil: "",
  login: "",
  instituicao: "",
};

export function formatarCpf(cpf) {
  const digitos = String(cpf || "").replace(/\D/g, "");
  if (digitos.length !== 11) {
    return cpf || "-";
  }
  return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export function inicialNome(nome) {
  const texto = String(nome || "?").trim();
  return texto.charAt(0).toUpperCase() || "?";
}

export function textoOuTraco(valor) {
  const texto = String(valor || "").trim();
  return texto || "-";
}

export function filtrosDaBusca(busca) {
  const termo = String(busca || "").trim();
  if (!termo) {
    return { ...FILTROS_VAZIOS };
  }
  const digitos = termo.replace(/\D/g, "");
  const temLetras = /[A-Za-zÀ-ÿ]/.test(termo);
  if (!temLetras && digitos) {
    return { ...FILTROS_VAZIOS, busca: termo, cpf: digitos };
  }
  return { ...FILTROS_VAZIOS, busca: termo, nome: termo };
}

export function montarFiltros({ busca = "", perfil = "", login = "", instituicao = "" }) {
  return {
    ...filtrosDaBusca(busca),
    perfil: String(perfil || "").trim(),
    login: String(login || "").trim(),
    instituicao: String(instituicao || "").trim(),
  };
}

export function ehUsuarioAtual(item, user) {
  const codigoAtual = String(user?.codigo_usuario || "");
  if (codigoAtual && String(item?.codigo || "") === codigoAtual) {
    return true;
  }
  const cpfItem = String(item?.cpf || "").replace(/\D/g, "");
  const cpfAtual = String(user?.cpf || "").replace(/\D/g, "");
  return Boolean(cpfItem && cpfAtual && cpfItem === cpfAtual);
}

export function textoRelativo(data, agora) {
  if (!data) {
    return "-";
  }
  const instante = new Date(data).getTime();
  if (Number.isNaN(instante)) {
    return "-";
  }
  const segundos = Math.max(0, Math.floor((agora - instante) / 1000));
  if (segundos < 45) {
    return "há poucos segundos";
  }
  const minutos = Math.floor(segundos / 60);
  if (minutos === 1) {
    return "há um minuto";
  }
  if (minutos < 60) {
    return `há ${minutos} minutos`;
  }
  const horas = Math.floor(minutos / 60);
  if (horas === 1) {
    return "há uma hora";
  }
  if (horas < 24) {
    return `há ${horas} horas`;
  }
  const dias = Math.floor(horas / 24);
  if (dias === 1) {
    return "há um dia";
  }
  return `há ${dias} dias`;
}
